const CURRENCY_BY_LOCALE = {
    "en-AU": "aud",
    "en-CA": "cad",
    "en-GB": "gbp",
    "ms-MY": "mmk",
    "zh-CN": "cny",
    "id-ID": "idr",
    "en-US": "usd",
    "en-SG": "sgd",
};
const DEFAULT_COUNTRY = 'AU';

const getCurrency = (currency) => {
    if (!currency) return 'aud';
    const countryCurrency = CURRENCY_BY_LOCALE[currency];
    return countryCurrency || 'aud';
};

const getStoreLocale = (store) => {
    if (!store) return DEFAULT_COUNTRY;
    return store.CurrencyLocaleName ? store.CurrencyLocaleName.replace("en-", "") : DEFAULT_COUNTRY;
};

export { getCurrency, getStoreLocale };
